import React, { useEffect, useState } from "react";
import { Close, CurrencyExchange } from "@mui/icons-material";
import { Button, Form, Input, Modal, Select } from "antd";
import { BeatLoader } from "react-spinners";
import http from "../../services/http";
import { toast } from "react-toastify";
import "./styles.scss";
import { useSelector } from "react-redux";

function ContactModal({ preview, closeHandler }) {
  const [isYearly, setisYearly] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const user = useSelector((state) => state.UserReducer.profile);

  const handleSubmit = (values) => {
    setLoading(true);
    http
      .post("email", { ...values, type: "upgrade", email: user.email })
      .finally(() => setLoading(false))
      .then(() => {
        form.resetFields();
        closeHandler();
        toast.success("Message sent successfully, we will get back to you");
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error ?? "Something went wrong");
      });
  };

  useEffect(() => {
    if (user) {
      const name = (user?.first_name ?? "") + " " + (user?.last_name ?? "");
      form.setFieldsValue({
        name: name,
        email: user.email,
      });
    }
  }, [user, preview]);

  return (
    <Modal
      centered
      width={650}
      open={preview}
      onCancel={closeHandler}
      footer={null}
      closable={false}
      className="contact-us-modal"
    >
      <div className="top-box">
        <h2>Contact us</h2>
        <button className="close-btn" onClick={closeHandler}>
          <Close />
        </button>
      </div>
      <Form form={form} onFinish={handleSubmit}>
        <label htmlFor="name">Name</label>
        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter your name",
            },
            {
              max: 50,
              message: "Name must not exceed 50 characters",
            },
          ]}
        >
          <Input id="name" placeholder="Enter your name" />
        </Form.Item>
        <label htmlFor="email">Email</label>
        <Form.Item
          name="email"
          // rules={[
          //   {
          //     required: true,
          //     message: "Please enter your email",
          //   },
          //   {
          //     type: "email",
          //     message: "Please enter a valid email",
          //   },
          // ]}
        >
          <Input disabled id="email" placeholder="Enter your email" />
        </Form.Item>
        <label htmlFor="message">Message</label>
        <Form.Item
          name="message"
          rules={[
            {
              required: true,
              message: "Please enter your message",
            },
            {
              max: 500,
              message: "Message must not exceed 500 characters",
            },
          ]}
        >
          <Input.TextArea
            rows={6}
            id="message"
            placeholder="Enter your message"
          />
        </Form.Item>
        <div className="modal-footer">
          <Button className="submit-btn" htmlType="submit">
            {isLoading ? <BeatLoader color="#fff" size={8} /> : "Submit"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default ContactModal;
